const _ = require('lib/underscore')
const definitiveArticleCountry = require('lib/definitive_article_country')

// child helper functions for locationDisplayName

function googleCity(location) {

    const matches = []
    const matching_types = ['sublocality', 'locality', 'administrative_area_level_1']

    matching_types.forEach(type => {
        location.components.forEach(component => {
            if (_.contains(component.types, type)) {
                matches.push(component.long_name)
            }
        })
    })

    return _.first(matches)
}

function googleRegion(location) {
    // returns state or province

    const matches = []
    const matching_types = ['administrative_area_level_1']

    matching_types.forEach(type => {
        location.components.forEach(component => {
            if (_.contains(component.types, type)) {
                let name = component.long_name
                // washington dc need short_name
                if (name === 'District of Columbia') {
                    name = component.short_name
                }
                matches.push(name)
            }
        })
    })

    return _.first(matches)

}

function googleCountry(location) {

    const matches = []
    const matching_types = ['country']

    matching_types.forEach(type => {
        location.components.forEach(component => {
            if (_.contains(component.types, type)) {
                matches.push(component.long_name)
            }
        })
    })

    return _.first(matches)

}

function googleDisplayName(location) {

    const city = googleCity(location)
    const region = googleRegion(location)
    const country = googleCountry(location)

    let parts = []
    if (city) parts.push(city)

    // since we're using administrative_area_level_1 as a possible match for
    // both city and region, it's possible to get that value back for both city
    // and region, e.g. Tokyo, Tokyo. However, since we only show the region if
    // country is USA and Canada (where region is always different than city),
    // we don't have to worry about this duplication being displayed. If the
    // logic below changes to show region for other countries, the getters for
    // city and region may need to be revisited.

    if (country === 'United States' || country === 'Canada') {
        if (region) parts.push(region)
    }

    // if city and/or state exist, only add country if not US
    if (parts.length && country !== 'United States') {
        // no 'the' if included with city and/or state
        parts.push(country)
    }

    // always include country if no other parts
    if (! parts.length) {
        parts.push(definitiveArticleCountry(country))
    }

    // make sure there is no duplicate data; cases: type 2 char state and will cause it
    parts = _.uniq(parts)

    return parts.join(', ')
}

const usa_regex = /, (US|USA|U\.S\.|U\.S\.A\.|United States|United States of America)$/

function googleStringDisplayName(location) {
    const loc = location.location.trim()

    // strip ", USA" and variants
    // leave rest unmodified
    return loc.trim().replace(usa_regex, '')
}

function locationDisplayName(location) {
    if (location.source === 'google') {
        return googleDisplayName(location)
    }
    if (location.source === 'google_string') {
        return googleStringDisplayName(location)
    }
    return location.location
}

module.exports = locationDisplayName
